import { Capacitor } from "@capacitor/core";
const NONE = {
    showFooter: false,
    showPlayStore: false,
    showAppGallery: false,
    showAppStore: false,
};
export const isNativeApp = () => Capacitor.isNativePlatform();
export const isPwaInstalled = () => {
    if (typeof window === "undefined")
        return false;
    const nav = window.navigator;
    return (window.matchMedia("(display-mode: standalone)").matches ||
        window.matchMedia("(display-mode: fullscreen)").matches ||
        nav.standalone === true);
};
export const isMobileUserAgent = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
export const isAndroidMobileBrowser = () => {
    if (isNativeApp())
        return false;
    return /Android/i.test(navigator.userAgent || "");
};
export const isIOSMobileBrowser = () => {
    if (isNativeApp())
        return false;
    return /iPhone|iPad|iPod/i.test(navigator.userAgent || "");
};
/**
 * Detecta Huawei/Honor/HarmonyOS.
 * En WebView nativo el UA suele traer huawei/hmscore/emui; también se mira
 * vendor y platform como refuerzo.
 */
export const isHuaweiDevice = () => {
    if (typeof navigator === "undefined")
        return false;
    const ua = String(navigator.userAgent || "").toLowerCase();
    const vendor = String(navigator.vendor || "").toLowerCase();
    const platform = String(navigator.platform || "").toLowerCase();
    const haystack = `${ua} ${vendor} ${platform}`;
    return /huawei|honor|harmonyos|hmscore|hiai|emui|hms\b/.test(haystack);
};
/** Capacitor nativo o PWA/standalone ya en ejecución. */
export const isInstalledApp = () => isNativeApp() || isPwaInstalled();
/**
 * Plataforma de la invitación a instalar.
 * Huawei tiene prioridad sobre Android genérico.
 */
export const getInstallPromptPlatform = () => {
    if (typeof navigator === "undefined")
        return "desktop";
    if (!isMobileUserAgent())
        return "desktop";
    if (isHuaweiDevice())
        return "huawei";
    if (isAndroidMobileBrowser())
        return "android";
    if (isIOSMobileBrowser())
        return "ios";
    return "desktop";
};
/**
 * Opciones de instalación en login según contexto de ejecución.
 * Solo se ofrecen tiendas nativas; la PWA queda a cargo del navegador.
 * - App nativa / PWA instalada → nada
 * - Web móvil Android (no Huawei) → Google Play
 * - Web móvil Huawei → AppGallery
 * - Web móvil iOS → App Store
 * - Web escritorio u otros → nada
 */
export const getLoginInstallOptions = () => {
    if (isInstalledApp())
        return NONE;
    const platform = getInstallPromptPlatform();
    if (platform === "desktop")
        return NONE;
    return {
        showFooter: true,
        showPlayStore: platform === "android",
        showAppGallery: platform === "huawei",
        showAppStore: platform === "ios",
    };
};
